import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectApi } from '@socialive/common';

export default createAsyncThunk(
  'mediaUpload/createUploadSession',
  async ({ channelToken, file, id }, { dispatch, getState }) => {
    const api = selectApi(getState());
    if (!api) throw new Error('API is required');

    const filename = `${id}_${file.name}`;

    const { sessionHash } = await api('/recording/create-session', {
      method: 'POST',
      data: {
        title: filename,
        token: channelToken,
      },
    });

    return { id, sessionHash, filename, originalName: file.name };
  }
);
